<template>
  <el-container v-resize:debounce="$handleResize" class="app-wrapper">
    <vue-progress-bar></vue-progress-bar>

    <el-header height='80'>
      <app-header></app-header>
    </el-header>
    <UserInfo v-if="isAuthenticated && (pageName === 'appraisal' || pageName === 'evaluator')"/>
    <LikertScale v-if="false && isAuthenticated && (pageName === 'appraisal'|| pageName === 'evaluator')"/>
    <el-main>
      <router-view></router-view>
    </el-main>
    <SectorSubmitBar :key="barKey" v-if="isAuthenticated && (pageName === 'appraisal' || pageName === 'evaluator')"/>
  </el-container>
</template>

<script>
import resize from 'vue-resize-directive'

import Header from '@/components/Header/Header'
import UserInfo from '@/components/UserInfo/UserInfo';
import LikertScale from '@/components/LikertScale/LikertScale.vue';
import SectorSubmitBar from '@/components/SectorSubmitBar/SectorSubmitBar.vue';

export default {
  name: 'App',
  directives: {
    resize
  },
  components: {
    'app-header': Header,
    UserInfo,
    LikertScale,
    SectorSubmitBar
  },
  computed: {
    barKey() {
      return this.$store.getters.barKey
    },
    isAuthenticated() {
      return this.$store.getters.isAuthenticated
    },
    pageName() {
      return this.$route.name
    },
    isEvaluator() {
      return this.$store.getters.isEvaluator
    }
  },
  methods: {
    initWindowWidth() {
      this.$handleResize()
    }
  },
  created() {
    this.initWindowWidth()
  }
}
</script>

<style src="@/assets/stylesheets/app.scss" lang="scss" ></style>
